import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import { AuthManage } from "providers";
import {
  HistoricRetentions,
  Login,
  NewTaxpayer,
  RetentionsInProcess,
  Root,
  Taxpayer,
  Taxpayers,
  PartnerCertificates,
  BulkActions,
  BulkInvoicing,
  DigitalStamps,
  BulkCommonInvoicing,
  UnifiedIssuing,
} from "pages";

import {
  routeCertificationsDelivery,
  routeHistoricRetentions,
  routeHome,
  routeLogin,
  routeNewTaxpayer,
  routeRetentionsInProcess,
  routeRoot,
  routeTaxpayer,
  routeTaxpayers,
  routeUploadFiles,
  routePartnerCertificates,
  routeBulkActions,
  routeBulkInvoicing,
  routeDigitalStamps,
  routeBulkCommonInvoicing,
  routeIssuancesInProgress,
  routeUnifiedIssuing,
} from "routes/pages";
import UploadFiles from "pages/UploadFiles/UploadFiles";
import CertificationsDelivery from "pages/CertificationsDelivery/CertificationsDelivery";
import { useEffect, useState } from "react";
import { getWhiteList } from "constants/whiteList";
import { IssuancesInProgress } from "pages/IssuancesInProgress/IssuancesInProgress";
import LoginSecure from "pages/Login/LoginSecure";
import { AuthMfaSecureProvider, useAuthMfaSecure } from "providers/AuthSecureManage/AuthMfaSecureManage";
import { SessionManage } from "providers/AuthManage/SessionManage";

// Componente interno que puede usar el hook
const AppContent = () => {
  const [modules, setModules] = useState<any[]>([]);

  const { listModules } = useAuthMfaSecure();

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const result = await listModules();
        setModules(result || []);
      } catch (error) {
        console.error('Error fetching modules:', error);
      }
    };
    fetchModules();
  }, [listModules]);

  const canAccessRTCertifications = modules.some((um) => um.modules?.type === 'rt_certifications');
  const canAccessPartnerCertificates = modules.some((um) => um.modules?.type === 'partner_certifications');
  const canAccessUploadFiles = modules.some((um) => um.modules?.type === 'upload_files');
  const canAccessCertificationsDelivery = modules.some((um) => um.modules?.type === 'certifications_delivery');
  const canAccessHistoricRetentions = modules.some((um) => um.modules?.type === 'historic_retentions');
  const canAccessBulkActions = modules.some((um) => um.modules?.type === 'certification');
  const canAccessBulkInvoicing = modules.some((um) => um.modules?.type === 'fc3');
  const canAccessBulkCommonInvoicing = modules.some((um) => um.modules?.type === 'common_invoices');
  const canAccessIssuancesInProgress = modules.some((um) => um.modules?.type === 'issuances_in_progress');
  
  const fc3PartnerId = modules.find((um) => um.modules?.type === 'fc3')?.partner?.numeric_id
    || modules[0]?.partner?.numeric_id;
  const certificationPartnerId = modules.find((um) => um.modules?.type === 'certification')?.partner?.numeric_id
    || modules[0]?.partner?.numeric_id;
  const historicRetentionsPartnerId = modules.find((um) => um.modules?.type === 'historic_retentions')?.partner?.numeric_id
    || modules[0]?.partner?.numeric_id;
  const canAccessUploadCSDFiles = modules.some((um) => um.modules?.type === 'upload_csd_files');


  return (
    <SessionManage>
      <Switch>
          <Redirect exact={true} from={routeRoot()} to={routeHome()} />

          <Route exact={true} path={routeLogin()}>
            <LoginSecure />
          </Route>

          <Route exact={true} path={routeDigitalStamps()}>
            <DigitalStamps />
          </Route>

          {/* canAccessRTCertifications */}
          {canAccessRTCertifications && (
            <Route exact={true} path={routeTaxpayers()}>
              <Taxpayers partnerId={certificationPartnerId}/>
            </Route>
          )}

          {/* canAccessPartnerCertificates */}
          {canAccessPartnerCertificates && (
            <Route exact={true} path={routePartnerCertificates()}>
              <PartnerCertificates />
            </Route>
          )}

          {/* canAccessUploadFile */}
          {canAccessUploadFiles && (
            <Route exact={true} path={routeUploadFiles()}>
              <UploadFiles />
            </Route>
          )}

          {/* canAccessCertificationsDelivery */}
          {canAccessCertificationsDelivery && (
            <Route exact={true} path={routeCertificationsDelivery()}>
              <CertificationsDelivery />
            </Route>
          )}

          {/* <Route exact={true} path={routeNewTaxpayer()}>
            <NewTaxpayer />
          </Route> */}

          <Route exact={true} path={routeTaxpayer({ taxpayerId: ":taxpayerId" })}>
            <Taxpayer />
          </Route>

          <Route exact={true} path={routeRetentionsInProcess()}>
            <RetentionsInProcess />
          </Route>

          {/* canAccessHistoricRetentions */}
          {canAccessHistoricRetentions && (
            <Route exact={true} path={routeHistoricRetentions()}>
              <HistoricRetentions partnerId={certificationPartnerId || historicRetentionsPartnerId} />
            </Route>
          )}

          {/* canAccessBulkActions */}
          {canAccessBulkActions && false && (
            <Route exact={true} path={routeBulkActions()}>
              <BulkActions />
            </Route>
          )}

          {/* canAccessBulkInvoicing */}
          {canAccessBulkInvoicing && false &&(
            <Route exact={true} path={routeBulkInvoicing()}>
              <BulkInvoicing />
            </Route>
          )}

          <Route exact={true} path={routeUnifiedIssuing()}>
            <UnifiedIssuing />
          </Route>

          {canAccessBulkCommonInvoicing && false && (
            <Route exact={true} path={routeBulkCommonInvoicing()}>
              <BulkCommonInvoicing />
            </Route>
          )}  

          {canAccessIssuancesInProgress && (
            <Route exact={true} path={routeIssuancesInProgress()}>
              <IssuancesInProgress />
            </Route>
          )}

          {canAccessUploadCSDFiles && (
            <Route exact={true} path={routeDigitalStamps()}>
              <DigitalStamps />
            </Route>
          )}

          <Route path={routeRoot()}>
            <Root />
          </Route>
      </Switch>
    </SessionManage>
  );
}

// Componente principal que envuelve con el provider
function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AuthMfaSecureProvider>
        <AppContent />
      </AuthMfaSecureProvider>
    </BrowserRouter>
  );
}

export default App;
